var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRacUpdatedLogoNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.838,
    height: 44.869,
    viewBox: "0 0 138.838 44.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.853,
    y1: 0.06,
    x2: 0.2,
    y2: 0.718,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f8f8f8",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10393",
    "data-name": "Group 10393",
    transform: "translate(-25 -26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37994",
    "data-name": "Path 37994",
    d: "M55.47,30.945V16h7.3a6.042,6.042,0,0,1,2.135.342,5.124,5.124,0,0,1,1.633.95,4.537,4.537,0,0,1,1.067,1.462,4.7,4.7,0,0,1,.384,1.879,4.27,4.27,0,0,1-.8,2.519A4.868,4.868,0,0,1,65.056,24.8l3.267,6.149H64.864l-2.936-5.722H58.566v5.722Zm7.024-12.276H58.566v4.014h3.928a2.445,2.445,0,0,0,1.676-.555,2,2,0,0,0,.085-2.818L64.17,19.2A2.445,2.445,0,0,0,62.494,18.669Z",
    transform: "translate(27.453 24.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37995",
    "data-name": "Path 37995",
    d: "M67.9,30.945,74.049,16h3.565L83.7,30.945H80.347l-1.516-3.928h-6.17l-1.537,3.928Zm5.722-6.4h4.27l-2.135-5.508Z",
    transform: "translate(28.292 24.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37996",
    "data-name": "Path 37996",
    d: "M90.62,28.312a5.081,5.081,0,0,0,2.2-.491,5.7,5.7,0,0,0,1.815-1.409l2.028,2.007a7.664,7.664,0,0,1-2.722,2.007,8.369,8.369,0,0,1-6.554.149,7.9,7.9,0,0,1-2.53-1.623,7.206,7.206,0,0,1-1.676-2.434,7.654,7.654,0,0,1,1.7-8.54,7.9,7.9,0,0,1,2.53-1.623,8.038,8.038,0,0,1,3.1-.576,8.38,8.38,0,0,1,3.48.758,7.472,7.472,0,0,1,2.733,2.039l-2.135,2.071a5.636,5.636,0,0,0-1.857-1.505,5.06,5.06,0,0,0-2.22-.523,4.772,4.772,0,0,0-1.889.374,4.526,4.526,0,0,0-1.526,1.067,4.462,4.462,0,0,0-1,1.537,4.974,4.974,0,0,0-.331,1.889,4.729,4.729,0,0,0,.374,1.911,4.473,4.473,0,0,0,1.068,1.526,4.643,4.643,0,0,0,1.537,1.067A4.793,4.793,0,0,0,90.62,28.312Z",
    transform: "translate(29.28 24.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37997",
    "data-name": "Path 37997",
    d: "M97.47,30.945V16h7.472a5.7,5.7,0,0,1,2.018.352,4.8,4.8,0,0,1,1.591.971,4.537,4.537,0,0,1,1.067,1.484,4.974,4.974,0,0,1,.374,1.889,4.793,4.793,0,0,1-.374,1.847,4.473,4.473,0,0,1-1.067,1.462,4.953,4.953,0,0,1-1.591.961,5.626,5.626,0,0,1-2.007.342h-4.4v5.636Zm7.152-12.276h-4.056v4.078h4.056a2.3,2.3,0,0,0,1.612-.555,1.911,1.911,0,0,0,.608-1.473,1.954,1.954,0,0,0-.608-1.484A2.252,2.252,0,0,0,104.622,18.669Z",
    transform: "translate(30.287 24.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29166",
    "data-name": "Path 29166",
    d: "M116.813,30.978V29.91a4.451,4.451,0,0,1-3.405,1.377,3.587,3.587,0,0,1-3.758-3.565c0-2.519,2.039-3.437,3.758-3.437a4.355,4.355,0,0,1,3.405,1.313V24.061c0-1.067-.929-1.8-2.359-1.8a4.558,4.558,0,0,0-3.2,1.27l-1.068-1.889a7.045,7.045,0,0,1,4.708-1.7c2.455,0,4.708.982,4.708,4.078v6.96Zm0-3.918a2.8,2.8,0,0,0-2.274-.939c-1.067,0-2.028.6-2.028,1.623s.918,1.591,2.028,1.591a2.829,2.829,0,0,0,2.274-.939Z",
    transform: "translate(31.109 25.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29167",
    "data-name": "Path 29167",
    d: "M129.112,31.221V29.854a4.27,4.27,0,0,1-3.331,1.623c-2.722,0-4.772-2.05-4.772-5.636s2.028-5.668,4.772-5.668a4.174,4.174,0,0,1,3.331,1.644V16.34h2.85V31.221Zm0-7.291a3.117,3.117,0,0,0-2.455-1.228c-1.612,0-2.722,1.27-2.722,3.149a2.8,2.8,0,0,0,2.722,3.117,3.117,3.117,0,0,0,2.455-1.249Z",
    transform: "translate(31.876 24.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37970",
    "data-name": "Path 37970",
    d: "M37.085,9.77c-1.708,1.516-28.4,26.58-28.4,26.58l15.468,8.188s17.08-32.153,17.08-32.58S37.085,9.77,37.085,9.77Z",
    transform: "translate(24.296 24.524)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37971",
    "data-name": "Path 37971",
    d: "M45.733,32.637A15.18,15.18,0,0,1,40.481,43,14.155,14.155,0,0,1,33.8,46.2a25.363,25.363,0,0,1-7.088.63,8.753,8.753,0,0,1-2.5-.566,3.106,3.106,0,0,1-2.039-3.875,3.2,3.2,0,0,1,.395-.811c1.633-2.946,3.352-5.85,5.039-8.764l10.034-17.4a3.64,3.64,0,0,0,.064-3.971,3.32,3.32,0,0,0-3.288-1.687,5.508,5.508,0,0,0-2,.747c-5.284,3.032-10.547,6.1-15.809,9.138-3.427,1.932-6.843,3.918-10.291,5.839a3.128,3.128,0,0,1-4.27-1.067,3.053,3.053,0,0,1-.363-.907,19.706,19.706,0,0,1-.438-4.686,23.239,23.239,0,0,1,.427-4.217A14.5,14.5,0,0,1,7.186,5.469a15.318,15.318,0,0,1,8.4-3.2C17.113,2.171,18.64,2,20.2,2H36.83a9.148,9.148,0,0,1,8.7,6.512,14.945,14.945,0,0,1,.48,3.64c.064,2.957,0,5.914,0,8.871C46.031,21.044,46.01,28.783,45.733,32.637Z",
    transform: "translate(23.793 24)",
    fill: "#3f7af5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37972",
    "data-name": "Path 37972",
    d: "M4.914,44.763h-3c-.512,0-.715-.181-.7-.694,0-2.071,0-4.142.107-6.2a5.946,5.946,0,0,1,3.939-4.846A6.042,6.042,0,1,1,9.2,44.444a3.2,3.2,0,0,1-.929.277Z",
    transform: "translate(23.791 26.071)",
    fill: "#c3453b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacUpdatedLogoNew);
export default __webpack_public_path__ + "static/media/RACUpdatedLogoNew.1e5fe67b9078725204caea7e633387f2.svg";
export { ForwardRef as ReactComponent };